import DateTime from '/app/src/lib/DateTime';

function body(entry){
    if(!entry)
        return '';
    if(entry.meta){
        switch (entry.meta.type){
            case 'ticket_transferred':
                return 'Överföring från ' + entry.meta.details.from_name;
            case 'ticket_assigned':
                return 'Ärenden hanteras nu av ' + entry.meta.details.user_name;
            case 'ticket_resolved':
                return 'Ärenden arkiveras av ' + entry.meta.details.user_name;
            case 'file':
                return  `${entry.meta.details.user_name} har lagt till en fil : ${entry.meta.details.file_name}`
            case 'autoresponse':
                if(entry.meta.details.type === 'email_exist'){
                    return 'Vi svarar så fort vi kan! Vill du istället att vi återkommer på email-adressen nedan?'
                }else{
                    return 'Vi svarar så fort vi kan, har du inte tid att vänta så kan vi återkomma på e-mailadressen nedan!'
                }
            case 'offline_message':
                return entry.entry_body;
            default:
                return entry.entry_body
        }
    }
    return entry.entry_body
}

function dateCreated(entry){
    if(!entry)
        return '';
    return  DateTime.getNiceDate(entry.date_created)
}
function detailsDateCreated(entry){
    if(!entry)
        return '';
    return  DateTime.getDetailedNiceDate(entry.date_created, true)
}

function creatorId(entry){
    if(!entry)
        return '';
    return  entry.creator_id
}


export default {
    body,
    dateCreated,
    detailsDateCreated,
    creatorId
}



// WEBPACK FOOTER //
// ./src/model/Entry/selector.js